import BulkEdit from './bulkEdit.container';

export default BulkEdit